import { render, staticRenderFns } from "./YoutubeShort.vue?vue&type=template&id=59b473a5&scoped=true"
import script from "./YoutubeShort.vue?vue&type=script&lang=js"
export * from "./YoutubeShort.vue?vue&type=script&lang=js"
import style0 from "./YoutubeShort.vue?vue&type=style&index=0&id=59b473a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b473a5",
  null
  
)

export default component.exports